import { darken, lighten, rgba } from "polished";
export const black = `#000`;
export const lightGrey = `#a3a3a3`;
export const darkGrey = `#656565`;
export const bgColor = `#b60000`;
export const zoomBtnBg = rgba(black, 0.6);
export const zoomBtnBgHover = darken(0.1, zoomBtnBg);
export const zoomBtnColor = `#fff`;
export const headerBg = `#a60000`;
export const headerColor = `#ffcccc`;
export const headerColorBold = `#fff`;
export const messageNickColor = `#ffcccc`;
export const messageUserColor = `#fff`;
export const messageUserBg = `#7b0000`;
export const messageUserLinkColor = `#ffc525`;
export const messageUserLinkHoverColor = `#fff`;
export const messageWelcomeColor = `#ff9999`;
export const messageSystemColor = `#fff`;
export const messageSupportColor = `#7b0000`;
export const messageSupportBg = "#fff";
export const messageSupportLinkColor = "#0091d4";
export const messageSupportLinkHoverColor = "#00ade6";
export const messageAdditionalColor = "#ff9999";
export const messageAdditionalBg = "#7B000066";
export const messageAdditionalLinkColor = "#ffc525";
export const messageAdditionalLinkHoverColor = "#fff";
export const typingStatusBg = `transparent`;
export const typingStatusColor = `#f99`;
export const inputBg = `#bababa`;
export const inputBgFocus = lighten(0.1, inputBg);
export const inputColor = `#202a2e`;
export const placeholderColor = `#202a2e`;
export const btnColor = `${black}`;
export const btnBg = `#889ba1`;
export const btnBgHover = darken(0.1, btnBg);
const theme = {
    colors: {
        bgColor,
        zoomBtnBg,
        zoomBtnBgHover,
        zoomBtnColor,
        headerBg,
        headerColor,
        headerColorBold,
        messageNickColor,
        messageUserColor,
        messageUserBg,
        messageUserLinkColor,
        messageUserLinkHoverColor,
        messageWelcomeColor,
        messageSystemColor,
        messageSupportColor,
        messageSupportBg,
        messageSupportLinkColor,
        messageSupportLinkHoverColor,
        messageAdditionalColor,
        messageAdditionalBg,
        messageAdditionalLinkColor,
        messageAdditionalLinkHoverColor,
        typingStatusBg,
        typingStatusColor,
        inputBg,
        inputBgFocus,
        inputColor,
        placeholderColor,
        btnColor,
        btnBg,
        btnBgHover,
    },
    variant: "desktop",
};
export default theme;
